import { Link } from "react-router-dom";
import Waves from "@/components/Waves";
import { ArrowRight, Phone } from "lucide-react";
import { motion } from "framer-motion";

export default function CtaBand() {
  return (
    <div data-testid="cta-band">
      <Waves front="#003366" back="rgba(0,123,255,0.45)" />
      <section className="bg-[#003366] text-white relative overflow-hidden">
        <div
          aria-hidden
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage:
              "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
            backgroundSize: "56px 56px",
          }}
        />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-24 flex flex-wrap items-center justify-between gap-10">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-blue-300">Free quotes · No obligation</p>
            <h2 className="font-display font-black uppercase tracking-tighter text-4xl md:text-5xl mt-4 leading-[1.02]">
              Got a project<br />on the go?
            </h2>
            <p className="mt-4 text-blue-100/90 text-base md:text-lg max-w-md leading-relaxed">
              Send through the details and Paul will come back with a straight answer and a fair price.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.12 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <Link
              to="/quote"
              data-testid="cta-band-quote-button"
              className="group inline-flex items-center justify-center gap-3 bg-white text-[#003366] px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] hover:bg-[#007bff] hover:text-white hover:scale-[1.03] transition-[background-color,color,transform] duration-200"
            >
              Request a Quote
              <ArrowRight size={16} className="transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
            <a
              href="tel:0415464900"
              data-testid="cta-band-call-button"
              className="inline-flex items-center justify-center gap-3 border border-white/40 text-white px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] hover:border-white hover:bg-white/10 transition-colors duration-200"
            >
              <Phone size={16} /> 0415 464 900
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
